<template>
    <img
        :src="url"
        alt="gold coin"
        loading="lazy"
        :class="$style[props.size]"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import GoldCoinLarge from './images/gold-coin-large.webp'
import GoldCoinSmall from './images/gold-coin-small.webp'

const props = defineProps<{
    size: 'small' | 'large'
}>()

const url = computed(() => (props.size === 'large' ? GoldCoinLarge : GoldCoinSmall))
</script>

<style module>
.small {
    width: 24px;
    height: 24px;
}

.large {
    width: 64px;
    height: 64px;
}
</style>
